import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Flex from '@react-css/flex';
import Modal from 'react-modal';
import { StyledForm } from "../../styled-components/StyledForm.style";
import api from '../../services/api';
import { StldRow } from "../../styled-components/StldRow.style";
import { StldColumn } from "../../styled-components/StldColumn.style";
import { StyledTableDentroDoCard } from "../../styled-components/StyledTableDentroDoCard.style";
import Swal from "sweetalert2";

export const ModalMesclarTimesheet = ({ timesheet, isOpen, onAfterOpen, onRequestClose, loadPage, setIsOpen }) => {
    const [ListaData, setListaData] = useState(null);
    const [loadingData, setLoadingData] = useState(false);
    const [loadingDataSalvando, setLoadingDataSalvando] = useState(false);
    const [tsSelecionados, setTsSelecionados] = useState([]);

    useEffect(() => {
        setTsSelecionados([])
        const asyncFn = async () => {
            if(isOpen) {
                setListaData(null);
                setLoadingData(true);
                const response = await api.get(`Timesheet/${timesheet?.timesheet?.idTimesheet}/mesclar`);
                setListaData(response.data);
                setLoadingData(false);
            }
        }
        asyncFn();
    }, [timesheet?.timesheet?.idTimesheet, isOpen])

    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '35%',
            overflowY: 'auto',
            minHeight: '45%',
            maxHeight: '90%',
            maxWidth: '100%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const formatCurrency = (value) => {
        if (!value) {
            return 'R$ 0,00';
        }

        return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 });
    };

    const formatDecimal = (value) => {
        if (value == null || value === undefined || value === 0) {
            return '0,00';

        }
        return value.toLocaleString('pt-br', { style: 'decimal', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const registrationFailure = (text = "Ops, ocorreu um erro!. Tente novamente em instantes.") => {
        Swal.fire({
            title: "Atenção",
            text: text,
            icon: "error",
            confirmButtonText: "OK",
        });
    }

    const mesclarTS = async () => {
        if(tsSelecionados.length == 0) {
            Swal.fire({
                title: "Atenção",
                text: "Selecione ao menos 1 TS!",
                icon: "error",
                confirmButtonText: "OK",
            });
            return 
        }
        Swal.fire({
            text: "Deseja realmente mesclar esses timesheets?",
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoadingDataSalvando(true);
                var idTimesheets = tsSelecionados.map(ts => ts.idTimesheet)
                idTimesheets.push(timesheet?.timesheet?.idTimesheet)
                var body = {
                    IdTimesheet: idTimesheets
                }
                await api.post(`Timesheet/mesclar`, body)
                .then(async (response) => {
                    loadPage().then(response => {
                        setIsOpen()
                        setLoadingDataSalvando(false);
                        Swal.fire({
                            title: "Sucesso",
                            text: "Timesheet mesclado com sucesso!",
                            icon: "success",
                            showConfirmButton: true
                        });
                    })
                })
                .catch((error) => {
                    setLoadingDataSalvando(false);
                    registrationFailure(error?.response?.data?.notification?.messageReturn)
                });
            }
          });
    }

    const addRemoveTS = (event, item) => {
        const isChecked = event.target.checked;

        if(isChecked) {
            setTsSelecionados([...tsSelecionados, item])
        }
        else {
            setTsSelecionados([...tsSelecionados.filter(ts=> ts.idTimesheet != item.idTimesheet)])
        }
    }

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={onRequestClose}
            contentLabel="Histórico"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <p className="modal-close" onClick={onRequestClose}>X</p>
            </StyledForm>
            <StyledForm>
                <Flex>
                    <Flex.Item className="modal-width">
                        <div className="position-relative form-group">
                            <p className="modal-title">Mesclar Timesheet</p>
                        </div>
                    </Flex.Item>
                </Flex>
                {
                    !loadingDataSalvando && 
                        <Flex>
                            {loadingData ? 
                                <StldRow>
                                    <div className="text-center">
                                        <div className="align-items-center">
                                            <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                            <div><strong style={{ color: "#EE4B21" }}>{'Atualizando...'}</strong></div>
                                        </div>
                                    </div>
                                </StldRow> : 
                            ''}
                            {
                                ListaData != null && ListaData?.data.length > 0 && (
                                    <StldColumn xs="12" sm="12" md="12" lg="12" xl="12">
                                        <StyledTableDentroDoCard>
                                            <div style={{fontSize: "13px"}} className="text-center"> Timesheets </div>
                                            <div className="table-responsive">
                                                <table className="table table-sm mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th className="text-center">Selecionar</th>
                                                            <th>Sigla</th>
                                                            <th>TS</th>
                                                            <th>Status</th>
                                                            <th>Total Horas</th>
                                                            <th>Valor Total</th>
                                                            <th className="text-center">Visualizar</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    {
                                                        ListaData != null && ListaData?.data?.map((item, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <th scope="row">
                                                                        <input type="checkbox" onChange={(e) => addRemoveTS(e, item)} />
                                                                    </th>
                                                                    <th scope="row" className="text-nowrap">{item.sigla}</th>
                                                                    <td className="text-nowrap">{item.timeSheetSigla}</td>
                                                                    <td> {item.statusTimeSheet} </td>
                                                                    <td className="text-nowrap">{formatDecimal(item.totalHorasFaturadas)}</td>
                                                                    <td className="text-nowrap">{formatCurrency(item.valorTotalFaturado)}</td>
                                                                    <td className="text-center">
                                                                        <Link target="_blank" className="menu-link" to={{ pathname: "/timesheetdetalhespage/", hash: item.idTimesheet }}>
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-box-arrow-up-right" viewBox="0 0 16 16">
                                                                                <path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5" />
                                                                                <path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z" />
                                                                            </svg>
                                                                        </Link>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </StyledTableDentroDoCard>
                                    </StldColumn>
                                )
                            }
        
                            {
                                ListaData?.data.length == 0 && <StldColumn xs="12" sm="12" md="12">
                                    <div className="alert alert-warning" role="alert">
                                        Atenção! Nenhum resultado encontrado!
                                    </div>
                                </StldColumn>
                            }
                        </Flex>
                }
            </StyledForm>
            {
                !loadingDataSalvando &&
                    <>
                        <StldColumn xs="12" sm="12" md="12" lg="12" xl="12">
                            <StldRow>
                                <StldColumn xs="12" sm="12" md="12" lg="12" xl="12">
                                    <StyledTableDentroDoCard>
                                        <div style={{fontSize: "13px"}} className="text-center mt-5"> TS Selecionados </div>
                                        <div className="table-responsive">
                                            <table className="table table-sm mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Sigla</th>
                                                        <th>TS</th>
                                                        <th>Status</th>
                                                        <th>Total Horas</th>
                                                        <th>Valor Total</th>
                                                        <th className="text-center">Visualizar</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    tsSelecionados != null && tsSelecionados.map((item, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <th scope="row" className="text-nowrap">{item.sigla}</th>
                                                                <td className="text-nowrap">{item.timeSheetSigla}</td>
                                                                <td> {item.statusTimeSheet} </td>
                                                                <td className="text-nowrap">{formatDecimal(item.totalHorasFaturadas)}</td>
                                                                <td className="text-nowrap">{formatCurrency(item.valorTotalFaturado)}</td>
                                                                <td className="text-center">
                                                                    <Link target="_blank" className="menu-link" to={{ pathname: "/timesheetdetalhespage/", hash: item.idTimesheet }}>
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-box-arrow-up-right" viewBox="0 0 16 16">
                                                                            <path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5" />
                                                                            <path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z" />
                                                                        </svg>
                                                                    </Link>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    </StyledTableDentroDoCard>
                                </StldColumn>
                            </StldRow>
                        </StldColumn>
                        <StyledForm>
                            <div className={`form-wrapper filter-container mt-2`} style={{width: "100%"}}>
                                <div className="position-relative form-group col-sm-12 col-md-12 col-lg-12 text-center mt-3">
                                    <input type="button" className='default-button-red' value='Mesclar Timesheets' onClick={() => mesclarTS()} />
                                </div>
                            </div>
                        </StyledForm>
                    </>
            }
            {
                loadingDataSalvando &&
                    <StldRow>
                        <div className="text-center">
                            <div className="align-items-center">
                                <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                <div><strong style={{ color: "#EE4B21" }}>{'Salvando...'}</strong></div>
                            </div>
                        </div>
                    </StldRow>
            }
        </Modal>
    );
};